import VueRouter from "vue-router";
import routes, {
  verifications_router_name,
  forbidden_router_name,
  dashboard_router_name
} from "./routes";
import { store } from "@/store";

const hasPermission = (to, userRole) => {
  const userCfg = { userRole: userRole };
  return to.matched.some(
    record => record.meta.activeRoute && record.meta.activeRoute(userCfg)
  );
};

const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["schoolAuth/isAuthenticated"];

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        name: verifications_router_name
      });
      return;
    }

    const userRole = store.getters["user/role"];
    if (userRole[0] && !hasPermission(to, userRole)) {
      next({ name: forbidden_router_name });
      return;
    }
    next();
    return;
  }

  if (to.matched.find(record => record.name === verifications_router_name)) {
    if (isAuthenticated) {
      return next({ name: dashboard_router_name });
    }
    next();
    return;
  }

  next();
});

export default router;
